import type React from "react"

export const BrewOnTapOutlineIcon = (props: React.ComponentProps<"svg">): JSX.Element => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        fill='none'
        viewBox='0 0 24 24'
        {...props}
    >
        <path
            fill='currentColor'
            fillRule='evenodd'
            d='M15.25 12.128a3.016 3.016 0 0 0 .89-1.92l.406-5.264a3.43 3.43 0 1 0-6.842 0l.405 5.263c.058.754.389 1.425.891 1.92V14.5H8.5a2 2 0 0 0-2-2h-.563A2 2 0 0 0 4 11H2.5c-.69 0-1.25.56-1.25 1.25v9.25c0 .69.56 1.25 1.25 1.25H4a2 2 0 0 0 1.937-1.5H6.5a2 2 0 0 0 1.985-1.75h4.62a2.626 2.626 0 0 1-2.53-2H8.5v-1h2.027a2.625 2.625 0 0 1 5.196 0h.258a4.77 4.77 0 0 1 4.741 4.25h-1.04a3.787 3.787 0 0 0-3.747-3.25h-.26a2.626 2.626 0 0 1-2.53 2h2.79c.986 0 1.785.8 1.785 1.786 0 .808.656 1.464 1.465 1.464h2.084a1.48 1.48 0 0 0 1.481-1.48 6.77 6.77 0 0 0-6.77-6.77h-.73v-2.372ZM13.125 3.25c-.834 0-1.49.71-1.427 1.54l.405 5.264a1.025 1.025 0 0 0 2.044 0l.405-5.263a1.43 1.43 0 0 0-1.427-1.541Zm-6.625 16V14.5H6v4.75h.5ZM13 13v1h.25v-1H13Zm-9.75 0H4v7.75h-.75V13Z'
            clipRule='evenodd'
        />
        <path
            fill='currentColor'
            fillRule='evenodd'
            d='M13.125 15.25a1.625 1.625 0 1 0 0 3.25 1.625 1.625 0 0 0 0-3.25ZM9.5 16.875a3.625 3.625 0 1 1 7.25 0 3.625 3.625 0 0 1-7.25 0Z'
            clipRule='evenodd'
        />
    </svg>
)
